import { render, staticRenderFns } from "./HelexiumLoader.vue?vue&type=template&id=1ae67310&scoped=true"
var script = {}
import style0 from "./HelexiumLoader.vue?vue&type=style&index=0&id=1ae67310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae67310",
  null
  
)

export default component.exports